module.exports = __webpack_public_path__ + "media/images/unpin-icon-442d23cd4c1f2380002d8ff55593f3a6.png";